import { paginationParams } from "@/utils/pagination";
import request from "@/utils/request";

export async function createNote(params) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/note-service/notes`, {
    method: "POST",
    data: params,
  });

  return result?.data;
}

export async function getAllNotes({ page = 1, pageSize = 10, id, sorting, category, includeHidden }) {
  const { SkipCount, MaxResultCount } = paginationParams(page, pageSize);

  const params = {
    SkipCount,
    MaxResultCount,
    EntityId: id,
    Sorting: sorting,
    Category: category,
    ...(includeHidden ? { IncludeHidden: true } : {}),
  };

  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/note-service/notes`, {
    params,
  });

  return result?.data;
}

export async function getNotesCount(referenceId) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/note-service/notes/count/${referenceId}`, {
    method: "GET",
  });

  return result?.data;
}
